import IcAnotaciones from './IcAnotaciones'

export default IcAnotaciones
